<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <div>
      <md-card class="card" style="margin: 1rem">
        <md-card-content>
          <md-layout md-gutter>
            <md-layout md-flex="45"></md-layout>
            <md-layout md-flex="50">
              <h3><b>Item Master</b></h3>
              <md-layout md-flex="10"></md-layout>
            </md-layout>
          </md-layout>

          <hr class="hr-s" />

          <b-row>
            <b-col md="3" class="mb-1">
              <md-layout md-flex="100">
                <label>Item Name <span class="error">*</span></label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="itemName"
                  name="itemName"
                  v-model="itemMaster.itemName"
                  :disabled="itemMaster.itemId == '' ? false : true"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!itemMaster.itemName">{{ itemNameError }}</span>
            </b-col>

            <b-col md="3" class="mb-1">
              <md-layout md-flex="100">
                <label>Part Number <span class="error mb-1">*</span></label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="part_number"
                  name="part_number"
                  v-model="itemMaster.part_number"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!itemMaster.part_number">{{
                partNumberError
              }}</span>
            </b-col>

            <b-col md="3" class="mb-1">
              <md-layout md-flex="100">
                <label>Item Category <span class="error mb-1">*</span></label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="item_category"
                  name="item_category"
                  v-model="itemMaster.item_category"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!itemMaster.item_category">{{
                itemCategoryError
              }}</span>
            </b-col>

            <b-col md="3" class="mb-1">
              <md-layout md-flex="100">
                <label> Item Unit <span class="error mb-1">*</span></label>
                <model-list-select
                  :list="UnitList"
                  v-model="itemMaster.unit"
                  option-value="unitVal"
                  option-text="unitText"
                  placeholder="Select Unit"
                ></model-list-select>
              </md-layout>
              <span class="error" v-if="!itemMaster.unit">{{ unitError }}</span>
            </b-col>

            <!-- <b-col md="2" class="mb-1">
              <md-layout md-flex="100">
                <label>Stocked-In Quantity <span class="error mb-1">*</span></label>
                <b-form-input type="number" min="0" :formatter="capitalizeAll" id="quantity" name="quantity"
                  v-model="itemMaster.quantity"></b-form-input>
              </md-layout>
              <span class="error" v-if="!itemMaster.quantity">{{ quantityError }}</span>
            </b-col> -->
            <!-- </b-row>

          <b-row> -->
            <!-- <b-col md="3" class="mb-1">
              <md-layout md-flex="100">
                <label>Rate Per Quantity <span class="error mb-1">*</span></label>
                <b-form-input :formatter="capitalizeAll" type="number" min="1" id="ratePerUnit" name="ratePerUnit"
                  v-model="itemMaster.ratePerUnit"></b-form-input>
              </md-layout>
              <span class="error" v-if="!itemMaster.ratePerUnit">{{
                ratePerUnitError
                }}</span>
            </b-col> -->

            <b-col md="3" class="mb-1">
              <md-layout md-flex="100">
                <label>Rack No.</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="rackNo"
                  name="rackNo"
                  v-model="itemMaster.rackNo"
                ></b-form-input>
              </md-layout>
            </b-col>

            <b-col md="3" class="mb-1">
              <md-layout md-flex="100">
                <label>Shelf No.</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="shelfNo"
                  name="shelfNo"
                  v-model="itemMaster.shelfNo"
                ></b-form-input>
              </md-layout>
            </b-col>

            <b-col md="3" class="mb-1">
              <md-layout md-flex="100">
                <label>Location </label>
                <model-list-select
                  :list="$store.getters['common/getAllBranchList']"
                  v-model="itemMaster.fk_loc_id"
                  option-value="pickupId"
                  option-text="pickupLocation"
                  placeholder=" Location"
                  @input="getLocDet('Location', itemMaster.fk_loc_id)"
                ></model-list-select>
                <!-- <b-form-input :formatter="capitalizeAll" id="location" name="location"
                  v-model="itemMaster.location"></b-form-input> -->
              </md-layout>
            </b-col>

            <b-col md="3" class="mb-1">
              <md-layout md-flex="100">
                <label>Spare Part Location</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="spare_part_location"
                  name="spare_part_location"
                  v-model="itemMaster.spare_part_location"
                ></b-form-input>
              </md-layout>
              <!-- <span class="error" v-if="!itemMaster.spare_part_location">{{sparePartLocError}}</span> -->
            </b-col>

            <b-col md="3" class="mb-1">
              <md-layout md-flex="100">
                <label>Workshop Location</label>
                <model-list-select
                  :list="$store.getters['common/getAllBranchList']"
                  v-model="itemMaster.fk_workshop_loc_id"
                  option-value="pickupId"
                  option-text="pickupLocation"
                  placeholder=" Workshop Location"
                  @input="
                    getLocDet('Workshop_Location', itemMaster.fk_workshop_loc_id)
                  "
                ></model-list-select>
               
                <!-- <b-form-input
                  :formatter="capitalizeAll"
                  id="workshop_location"
                  name="workshop_location"
                  v-model="itemMaster.workshop_location"
                ></b-form-input> -->
              </md-layout>
              <!-- <span class="error" v-if="!itemMaster.workshop_location">{{workshopLocError}}</span> -->
            </b-col>
            <!-- </b-row>

          <b-row> -->
            <b-col md="3">
              <label>Maintenance Type <span class="error">*</span></label>
              <model-list-select
                :list="maintenanceTypeList"
                id="maintenance_type"
                v-model="itemMaster.maintenance_type"
                option-value="maintenanceTypeVal"
                option-text="maintenanceTypeText"
                placeholder="Maintenance Type"
              ></model-list-select>
              <span class="error" v-if="!itemMaster.maintenance_type">{{
                maintenanceTypeError
              }}</span>
            </b-col>

            <b-col md="6">
              <label>Remarks</label>
              <b-form-textarea
                :formatter="capitalizeAll"
                id="remarks"
                name="remarks"
                v-model="itemMaster.remarks"
              ></b-form-textarea>
            </b-col>

            <b-col md="1" class="mt-5 mb-1">
              <b-button
                variant="primary"
                size="sm"
                class="py-2"
                @click="addItem"
                id="addButtonLoader"
              >
                {{ itemMaster.itemId == "" ? "Add New Item" : "Update Item" }}
              </b-button>
            </b-col>

            <b-col md="1" class="mt-5 mb-1">
              <b-button
                v-if="itemMaster.itemId != '' && itemMaster.unit == 'pcs'"
                @click="openQuantityModal(itemMaster.itemId, 'yes')"
                variant="info"
                id="quantityDetailsButton"
                size="sm"
                class="py-2"
              >
                Sub-Item Details
              </b-button>
            </b-col>
          </b-row>

          <b-modal
            no-close-on-esc
            no-close-on-backdrop
            size="xl"
            ref="Item-modal"
            title="Sub Item List"
            centered
          >
            <b-col md="12">
              <b-button
                class="mb-2"
                variant="primary"
                @click="openQuantityModal(itemMaster.itemId, '')"
              >
                All Items
              </b-button>

              <b-button
                class="mb-2"
                variant="primary"
                @click="openQuantityModal(itemMaster.itemId, 'yes')"
              >
                Show Only Stocked-In items
              </b-button>

              <b-form-group>
                <b-input-group>
                  <b-form-input
                    :formatter="capitalizeAll"
                    v-model="subItemfilter"
                    placeholder="Type to Search sub Item"
                  />
                  <b-input-group-append>
                    <b-button :disabled="!subItemfilter" @click="subItemfilter = ''"
                      >Clear</b-button
                    >
                  </b-input-group-append>
                  <h5 class="text-muted pull-right mt-2 ml-3">
                    <small v-if="isLoading == false"
                      >{{ totalRowsSubItem }} Sub Items</small
                    >
                  </h5>
                </b-input-group>
              </b-form-group>
            </b-col>

            <div class="table-responsive tableMain">
              <b-table
                show-empty
                stacked="md"
                :items="subItemList"
                :fields="subItemfields"
                :current-page="currentPage"
                :per-page="perPageSubItem"
                :filter="subItemfilter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                @filtered="onSubItemFiltered"
              >
                <template slot="itemId" slot-scope="row0">
                  <span>{{ row0.index + 1 + (currentPage - 1) * perPageSubItem }}</span>
                </template>

                <template slot="subItemName" slot-scope="row1">
                  <span>{{ row1.item.sub_item_name }}</span>
                </template>

                <template slot="serialNo" slot-scope="row2">
                  <span>{{ row2.item.sub_item_code }}</span>
                </template>

                <template slot="installationDate" slot-scope="row3">
                  <span>{{ row3.item.installation_date }}</span>
                </template>

                <template slot="manufacturingDate" slot-scope="row4">
                  <span>{{ row4.item.manufacture_date }}</span>
                </template>

                <template slot="expiryDate" slot-scope="row5">
                  <span>{{ row5.item.expiry_date }}</span>
                </template>

                <template slot="stockReceivedDate" slot-scope="row6">
                  <span>{{ row6.item.sub_item_received_date }}</span>
                </template>

                <template slot="stockReceivedBy" slot-scope="row7">
                  <span>{{ row7.item.receivedBy }}</span>
                </template>

                <template slot="stockoutdate" slot-scope="row8">
                  <span>{{ row8.item.sub_item_stockout_date }}</span>
                </template>
              </b-table>
            </div>

            <b-row>
              <b-col md="12" class="my-1">
                <b-pagination
                  limit="25"
                  :total-rows="totalRowsSubItem"
                  :per-page="perPageSubItem"
                  v-model="currentPage"
                  class="my-0 pull-right"
                />
              </b-col>
            </b-row>
          </b-modal>

          <hr />
          <div class="box">
            <div class="box-header">
              <h3 class="box-title"><b>Item Details</b></h3>
              <b-row class="gutr">
                <b-col md="6">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input
                        :formatter="capitalizeAll"
                        v-model="filter"
                        placeholder="Search Item Name / Part No / Category / Location"
                      />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''"
                          >Clear</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <model-list-select
                    :list="statusList"
                    v-model="itemStatusFilter"
                    option-value="statusVal"
                    option-text="statusText"
                    placeholder="Select Status"
                    @input="onStatusFilterChange"
                  ></model-list-select>
                </b-col>
                <b-col md="4">
                  <b-button
                    variant="primary"
                    size="sm"
                    class="md-2 mb-3 mr-1"
                    @click="openBulkUploadModal"
                  >
                    Bulk Upload
                  </b-button>
                  <b-button
                    :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
                    class="md-2 mb-3"
                    size="sm"
                    variant="warning"
                    @click="viewitemDetail('Excel')"
                  >
                    {{ ExcelBtnName }}
                    <b-spinner
                      v-if="ExcelBtnName != 'Export As Excel'"
                      small
                      label="Small Spinner"
                    ></b-spinner>
                  </b-button>
                  <b-button
                    class="md-2 mb-3 ml-1"
                    :disabled="ExcelBtnName1 != 'Export SubItem As Excel' ? true : false"
                    @click="getExportExcelSubItemList()"
                    size="sm"
                    style="font-size: 0.675rem"
                    variant="warning"
                  >
                    {{ ExcelBtnName1 }}
                    <b-spinner
                      v-if="ExcelBtnName1 != 'Export SubItem As Excel'"
                      small
                      label="Small Spinner"
                    ></b-spinner
                  ></b-button>

                  <h5 class="text-muted pull-right mt-2 ml-3">
                    <small v-if="isLoading == false">{{ totalRows }} Items</small>
                  </h5>
                </b-col>
              </b-row>
            </div>

            <div class="table-responsive tableMain">
              <b-table
                show-empty
                stacked="md"
                :items="stockList"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
              >
                <template slot="itemId" slot-scope="row0">
                  <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
                </template>

                <!-- <template slot="itemcode" slot-scope="row1">
                  <span>{{row1.item.itemCode}}</span>
                </template> -->

                <template slot="itemName" slot-scope="row2">
                  <span>{{ row2.item.itemName }}</span>
                  <br />
                  <b-button
                    v-if="row2.item.unit == 'pcs' && row2.item.itemId"
                    variant="primary"
                    size="sm"
                    style="font-size: 0.675rem"
                    class="py-2"
                    @click="openUpdateSubItemModal(row2.item)"
                    id="addButtonLoader"
                  >
                    Sub Item's
                  </b-button>
                  <!-- <span>{{ row2.item.unit }}</span> -->
                </template>

                <template slot="itemCategory" slot-scope="row3">
                  <span>{{ row3.item.item_category }}</span>
                </template>

                <template slot="partNumber" slot-scope="row4">
                  <span>{{ row4.item.part_number }}</span>
                </template>

                <template slot="sparePartLocation" slot-scope="row5">
                  <span>{{ row5.item.spare_part_location }}</span>
                </template>

                <template slot="loc_name" slot-scope="row6">
                  <span>{{ row6.item.loc_name }}</span>
                </template>

                <template slot="work_loc_name" slot-scope="row6">
                  <span>{{ row6.item.work_loc_name }}</span>
                </template>

                <!-- <template slot="ratePerUnit" slot-scope="row7">
                  <span>{{
                    row7.item.FirstpoRatePerUnit == ""
                    ? row7.item.ratePerUnit
                    : row7.item.FirstpoRatePerUnit
                    }}</span>
                </template> -->

                <template slot="unit" slot-scope="row14">
                  <span>{{ row14.item.unit }}</span>
                </template>

                <!-- <template slot="quantityAvailable" slot-scope="row8">
                  <span v-if="
                      parseInt(row8.item.quantity) - parseInt(row8.item.stockOutNumber) >
                      0
                    ">{{
                    parseInt(row8.item.stockOutNumber) == 0
                    ? row8.item.quantity
                    : parseInt(row8.item.quantity) -
                    parseInt(row8.item.stockOutNumber)
                    }}</span>
                  <span class="error" v-else> <b>Out of stock</b> </span>
                </template>

                <template slot="totalStockIn" slot-scope="row9">
                  <span>{{ row9.item.quantity }}</span>
                </template> -->

                <!-- <template slot="stockOutNumber" slot-scope="row10">
                  <span>{{
                    row10.item.stockOutNumber ? row10.item.stockOutNumber : 0
                    }}</span>
                </template> -->

                <template slot="maintenanceType" slot-scope="row11">
                  <span>{{ row11.item.maintenance_type }}</span>
                </template>

                <template slot="remarks" slot-scope="row12">
                  <span>{{ row12.item.remarks }}</span>
                </template>

                <template slot="isActiveItem" slot-scope="row12">
                  <div v-if="adminToggle == 'Admin'" :id="'row' + row12.item.itemId">
                    <md-switch
                      :id="'approval' + row12.item.itemId"
                      name="approval"
                      class="md-primary"
                      :value="row12.item.isActiveItem == 1 ? true : false"
                      @change="activateItem(row12.item)"
                    >
                      <h6>
                        <br />
                        <b-badge style="margin-left: -45px">{{
                          row12.item.isActiveItem == 1 ? "Active" : "In-Active"
                        }}</b-badge>
                      </h6>
                    </md-switch>
                  </div>
                </template>
                <template slot="view" slot-scope="row13">
                  <md-button
                    class="md-icon-button md-raised md-dense"
                    @click="viewItemPage(row13.item.itemId)"
                  >
                    <md-icon>edit</md-icon>
                  </md-button>
                </template>
              </b-table>
            </div>

            <b-row>
              <b-col md="12" class="my-1">
                <b-pagination
                  limit="25"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                  class="my-0 pull-right"
                />
              </b-col>
            </b-row>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <!-- Subitem List Modal Start -->
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="Sub-Item-Modal"
      hide-footer
      :title="'Sub Item List'"
    >
      <b-table show-empty stacked="md" :items="PS_subItemList" :fields="PS_subItemFields">
        <template slot="SN" slot-scope="row0">
          <span>{{ row0.index + 1 }}</span>
        </template>
        <template slot="is_quanity" slot-scope="row1">
          <div :id="'row' + row1.item.lead_id">
            <md-switch
              :id="'approval' + row1.item.lead_id"
              name="approval"
              class="md-primary"
              :value="row1.item.is_quanity == 1 ? true : false"
              @change="isQuanityMinus(row1.item)"
              :disabled="true"
            >
              <!-- ($sessionsStorage.get('designation') != 'Admin' && -->
              <!-- $sessionsStorage.get('nameUser') != 'Bhavneesh') || -->
              <h6>
                <br />
                <b-badge :variant="row1.item.is_quanity == 1 ? 'success' : 'danger'">{{
                  row1.item.is_quanity == 1 ? "Done" : "Pending"
                }}</b-badge>
              </h6>
            </md-switch>
          </div>
        </template>
      </b-table>
      <b-row>
        <b-col md="12"> </b-col>
        <b-col cols="12" class="text-center">
          <b-button
            class="mt-3"
            variant="outline-danger"
            size="xs"
            style="font-size: 0.675rem"
            @click="hideSubItemModal"
            >Close</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <!-- Subitem List Modal End -->

    <!-- Bulk Upload Modal -->
    <b-modal
      id="bulk-upload-modal"
      ref="Bulk-Upload-Modal"
      title="Bulk Upload Items"
      size="xl"
      hide-footer
    >
      <ItemMasterBulkUpload @upload-success="handleUploadSuccess" />
    </b-modal>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose"
      ref="addPop"
    ></md-dialog-confirm>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop1"
    ></md-dialog-alert>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";
import { ModelListSelect } from "vue-search-select";
import MaintenanceService from "../../../services/MaintenanceService.js";
import ClientUserService from "../../../services/ClientUserService.js";
import ItemMasterBulkUpload from "./ItemMasterBulkUpload.vue";
import ItemMasterService from "../../../services/ItemMasterService.js";
export default {
  beforeMount() {
    this.$store.dispatch(
      "common/setAllBranchList",
      JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    );
    if (globalPermissionStatus("Maintanence")) {
      this.$store.dispatch("setCurrentRoute", "/itemMaster/itemMaster");
      this.viewitemDetail("Normal");
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      adminToggle: this.$sessionsStorage.get("designation"),
      itemStatusFilter: "1",
      statusList: [
        {
          statusVal: "",
          statusText: "All",
        },
        {
          statusVal: "1",
          statusText: "Active",
        },
        {
          statusVal: "0",
          statusText: "In-Active",
        },
      ],
      PS_subItemList: [],
      PS_subItemFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "itemName",
          mainkey: "itemName",
          label: "Item Name",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "sub_item_name",
          mainkey: "sub_item_name",
          label: "Sub Item Name",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "sub_item_code",
          mainkey: "sub_item_code",
          label: "Sub Item Code",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "is_quanity",
          mainkey: "is_quanity",
          label: "Quantity",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "is_stcok_out",
          mainkey: "is_stcok_out",
          label: "Stock Out Status",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "createdBy",
          mainkey: "createdBy",
          label: "Created By",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "created_at",
          mainkey: "created_at",
          label: "Created Date",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "updatedBy",
          mainkey: "updatedBy",
          label: "Updated By",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "updated_at",
          mainkey: "updated_at",
          label: "Updated Date",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
      ],
      ExcelBtnName: "Export As Excel",
      ExcelBtnName1: "Export SubItem As Excel",

      subItemList: [],
      totalRowsSubItem: "",
      perPageSubItem: 5,
      subItemfilter: null,

      subItemfields: [
        {
          key: "itemId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "subItemName",
          label: "Sub Item Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "serialNo",
          label: "Serial No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "installationDate",
          label: "Installation Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "manufacturingDate",
          label: "Manufacturing Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "expiryDate",
          label: "Expiry Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "stockReceivedDate",
          label: "Stock Received Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "stockReceivedBy",
          label: "Stock Received By",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "stockoutdate",
          label: "Stock Out Date",
          sortable: true,
          sortDirection: "desc",
        },
      ],

      fields: [
        {
          key: "itemId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc",
        },
        // {
        //   key: "itemCode",
        //   label: "Item Code",
        //   sortable: true,
        //   sortDirection: "desc"
        // },
        {
          key: "itemName",
          label: "Item Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "itemCategory",
          label: "Item Category",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "loc_name",
          label: "Location",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "partNumber",
          label: "Part Number",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "sparePartLocation",
          label: "Spare Part Location",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "work_loc_name",
          label: "Workshop Location",
          sortable: true,
          sortDirection: "desc",
        },
        // {
        //   key: "ratePerUnit",
        //   label: "Rate Per Unit",
        //   sortable: true,
        //   sortDirection: "desc",
        // },
        {
          key: "unit",
          label: "Unit type",
          sortable: true,
          sortDirection: "desc",
        },
        // {
        //   key: "quantityAvailable",
        //   label: "Available Quantity",
        //   sortable: true,
        //   sortDirection: "desc",
        // },
        // {
        //   key: "totalStockIn",
        //   label: "Total Stock In",
        //   sortable: true,
        //   sortDirection: "desc",
        // },
        // {
        //   key: "stockOutNumber",
        //   label: "Total Stock out",
        //   sortable: true,
        //   sortDirection: "desc",
        // },
        {
          key: "maintenanceType",
          label: "maintenance Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "remarks",
          label: "Remarks",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "isActiveItem",
          label: "Status",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "view",
          label: "View",
          sortable: true,
          sortDirection: "desc",
        },
      ],

      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      searchTimer: null,

      isLoading: false,
      isFetching: false,
      itemMaster: {
        itemId: "",
        itemName: "",
        itemCode: "",
        part_number: "",
        item_category: "",
        rackNo: "",
        shelfNo: "",
        quantity: "",
        unit: "",
        ratePerUnit: "",
        location: "",
        spare_part_location: "",
        workshop_location: "",
        fk_loc_id:"",
        fk_workshop_loc_id:"",
        maintenance_type: "",
        remarks: "",
      },

      itemNameError: "",
      partNumberError: "",
      itemCategoryError: "",
      quantityError: "",
      unitError: "",
      ratePerUnitError: "",
      sparePartLocError: "",
      workshopLocError: "",
      maintenanceTypeError: "",

      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },

      clientId: "",
      stockList: [],

      UnitList: [
        {
          unitVal: "pcs",
          unitText: "Pcs",
        },
        {
          unitVal: "small pcs",
          unitText: "Small Pcs",
        },
        {
          unitVal: "kg",
          unitText: "Kg",
        },
        {
          unitVal: "litre",
          unitText: "Litre",
        },
      ],

      maintenanceTypeList: [
        {
          maintenanceTypeVal: "transport",
          maintenanceTypeText: "Transport",
        },
        {
          maintenanceTypeVal: "yard",
          maintenanceTypeText: "Yard",
        },
        {
          maintenanceTypeVal: "office",
          maintenanceTypeText: "Office",
        },
      ],
    };
  },

  mounted() {},
  watch: {
    currentPage() {
      if (!this.isFetching) {
        this.viewitemDetail("Normal");
      }
    },
    filter() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.currentPage = 1;
        this.viewitemDetail("Normal");
      }, 500);
    },
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    ModelListSelect,
    ItemMasterBulkUpload,
  },

  computed: {
    sortOptions() {
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },

  methods: {
    getLocDet(type, loc_id) {
      let arrayLoc = this.$store.getters["common/getAllBranchList"].filter((x) => {
        return x.pickupId == loc_id;
      });
      if (arrayLoc.length > 0) {
        if (type == "Workshop_Location") {
          this.itemMaster.workshop_location = arrayLoc[0].pickupLocation;
        } else if (type == "Location") {
          this.itemMaster.location = arrayLoc[0].pickupLocation;
        }
      }
    },
    activateItem(item) {
      this.itemObj = item;

      this.itemObj.isActiveItem = this.itemObj.isActiveItem == 1 ? 0 : 1;
      let paylod = {
        tableName: "main_itemmaster",
        tableId: "itemId",
        tableIsActive: "isActiveItem",
        value1: this.itemObj.isActiveItem,
        tableVal: item.itemId,
        isMailSend: "No",
        manual: "No",
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
          }
        })
        .catch((error) => {
          console.log("Catch on Proforma Error: ", error);
        });
    },
    openUpdateSubItemModal(item) {
      this.PS_subItemList = [];
      console.log("Item=>", item);
      let payload = {
        item_id: item.itemId,
        item_name: item.itemName,
        itemCode: "getSubItemList",
      };
      MaintenanceService.getAllMaintenanceList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data.subItemList.length > 0) {
            this.PS_subItemList = data.subItemList;
            this.$refs["Sub-Item-Modal"].show();
          }
          console.log("subItemList=>", this.PS_subItemList);
        })
        .catch((error) => {
          console.log("Catch on getSubItemList Error: ", error);
        });
    },
    hideSubItemModal() {
      this.PS_subItemList = [];
      this.$refs["Sub-Item-Modal"].hide();
    },
    getExportExcelSubItemList() {
      this.ExcelBtnName1 = "Downloading Please Wait .....";
      let payload = {
        itemCode: "getExportExcelSubItemList",
        type: "Excell",
      };
      MaintenanceService.getAllMaintenanceList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data.subItemList.length > 0) {
            this.ExcelBtnName1 = "Export SubItem As Excel";
            window.location.href =
              `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
          }
        })
        .catch((error) => {
          console.log("Catch on getExportExcelSubItemList Error: ", error);
        });
    },
    openQuantityModal(itemID, stockOut) {
      console.log("salil", itemID);
      // this.doLoading();
      this.$refs["Item-modal"].show();

      let payload = {
        view: "Quantity_details",
        itemID: itemID,
        stockOut: stockOut,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/viewItemDetail.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.subItemsArray.length > 0) {
              this.subItemList = data.subItemsArray;
              this.totalRowsSubItem = data.subItemsArray.length;
            } else {
              this.subItemList = [];
              this.totalRowsSubItem = "";
            }
            this.doLoadingClose();
          }
        })
        .catch((error) => {});
    },

    closeModal() {
      this.$refs["Item-modal"].hide();
    },

    onSubItemFiltered(filteredItems) {
      this.totalRowsSubItem = filteredItems.length;
      this.currentPage = 1;
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onStatusFilterChange() {
      this.currentPage = 1;
      this.viewitemDetail("Normal");
    },

    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    viewItemPage(itemID) {
      let array = this.stockList.filter((x) => {
        return x.itemId == itemID;
      });

      Object.keys(this.itemMaster).map((x) => {
        this.itemMaster[x] = array[0][x] || "";
      });
    },

    JqueryFun() {
      return $(function () {
        return $("#viewSalesBooking").DataTable();
      });
    },
    previousItemView() {},

    viewitemDetail(type) {
      this.ExcelBtnName = "Downloading Please Wait...";

      if (type == "Normal") {
        this.doLoading();
        this.ExcelBtnName = "Export As Excel";
      }

      let payload = {
        view: "itemMaster",
        type: type,
        itemStatusFilter: this.itemStatusFilter,
        page: this.currentPage,
        limit: this.perPage,
        search: this.filter || '',
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/viewItemDetail.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      this.isFetching = true;
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (type == "Excel") {
              this.ExcelBtnName = "Export As Excel";
              if (data.excelName) {
                window.location.href =
                  `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
              }
            } else {
              if (data.itemArray && data.itemArray.length > 0) {
                this.stockList = data.itemArray;
                this.totalRows = data.totalRows || data.itemArray.length;
              } else {
                this.stockList = [];
                this.totalRows = 0;
              }
            }
            this.doLoadingClose();
          }
        })
        .catch((error) => { console.log("viewitemDetail error:", error); })
        .finally(() => { this.isFetching = false; });
    },
    onClose(type) {},

    validateItemMaster() {
      let validate_new = true;

      if (this.itemMaster.itemName == "") {
        $("#itemName").focus();
        this.itemNameError = "Item Name Required";
        validate_new = false;
      }

      if (this.itemMaster.part_number == "") {
        $("#part_number").focus();
        this.partNumberError = "Part Number Required";
        validate_new = false;
      }

      if (this.itemMaster.item_category == "") {
        $("#item_category").focus();
        this.itemCategoryError = "Item Category Required";
        validate_new = false;
      }

      // if (this.itemMaster.quantity == "") {
      //   $("#quantity").focus();
      //   this.quantityError = "Qty Required";
      //   validate_new = false;
      // }

      if (this.itemMaster.unit == "") {
        $("#unit").focus();
        this.unitError = "Unit Required";
        validate_new = false;
      } else {
        this.unitError = "";
      }

      // if (this.itemMaster.ratePerUnit == "") {
      //   $("#ratePerUnit").focus();
      //   this.ratePerUnitError = "Enter Rate Per Unit";
      //   validate_new = false;
      // } else {
      //   this.ratePerUnitError = "";
      // }

      if (this.itemMaster.maintenance_type == "") {
        $("#maintenance_type").focus();
        this.maintenanceTypeError = "Select Maintenance Type";
        validate_new = false;
      } else {
        this.maintenanceTypeError = "";
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addItem() {
      // let array = this.stockList.filter(x => {
      //   return (
      //     x.itemName == this.itemMaster.itemName &&
      //     x.itemCode == this.itemMaster.itemCode
      //   );
      // });

      // if (array.length > 0 && this.itemMaster.itemId == "") {
      //   this.alert.content = "Item Already Exists";
      //   this.$refs["addPop1"].open();

      //   return false;
      // }

      this.validateItemMaster();
      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Maintenance/addItem.php`,
          data: JSON.stringify(this.itemMaster),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (data.clientId != "" && status == 200 && data) {
              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");

              // if (this.itemMaster.itemId == "") {
              //   this.alert.content = "Data Added Successfully";
              // } else {
              //   this.alert.content = "Data Updated Successfully";
              // }

              this.isLoading = false;
              this.alert.content = data.msg;
              this.$refs["addPop"].open();

              Object.keys(this.itemMaster).map((x) => {
                this.itemMaster[x] = "";
              });
              this.viewitemDetail("Normal");

              // this.JqueryFun();
            }
          })
          .catch((error) => {});
      }
    },
    openBulkUploadModal() {
      this.$refs["Bulk-Upload-Modal"].show();
    },
    handleUploadSuccess(data) {
       this.$refs["Bulk-Upload-Modal"].hide();
       this.alert.content = data.message;
       this.$refs["addPop"].open(); // Reusing the success modal/alert from add item
       this.viewitemDetail("Normal");
    },
  },
};
</script>
<style>
.md-button-color {
  background-color: #607d8d !important;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// itemMaster.vue?04d1b52f